import config from '@/config'

export default {
	id: 'SIMPLE_IN_APP_3M_59_99_3M_20_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_ios_3m_59_99_3m_20_99_usd',
		},
		primer: 'prd_3d0yVgSg1aR9',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 20.99,
		},
		originalPriceMap: {
			USD: 59.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 59.99,
		},
	},
}
